export const ADD_ROOM_REQUEST = 'ADD_ROOM_REQUEST'
export const ADD_ROOM_SUCCESS = 'ADD_ROOM_SUCCESS'
export const ADD_ROOM_FALIURE = 'ADD_ROOM_FALIURE'
